<template>
  <div id="app">
    <CarpetBackground :scale="480" :vignette="true" />
    <SiteNav />
    <router-view />
    <SiteFooter />
    <!-- Last, and outside the header: the drawer covers the page, the footer
         and the header's own menu, and only the header's z-index 100 is in the
         way of that. -->
    <CartDrawer />
    <!-- Above even the drawer: consent has to stay answerable whatever else is
         open over the page. -->
    <CookieBanner />
  </div>
</template>

<script>
import CarpetBackground from './components/CarpetBackground.vue';
import SiteNav from './components/SiteNav.vue';
import SiteFooter from './components/SiteFooter.vue';
import CartDrawer from './components/CartDrawer.vue';
import CookieBanner from './components/CookieBanner.vue';
import { catalogue } from './store/catalogue.js';
import { cartStore } from './store/cart.js';

export default {
  name: 'App',
  components: {
    CarpetBackground, SiteNav, SiteFooter, CartDrawer, CookieBanner,
  },
  /* Both fired once for the whole session, and neither awaited: the site is
     readable without either of them, and a shop that is slow to answer must
     not hold the carpet back. */
  created() {
    catalogue.load();
    cartStore.restore();
  },
};
</script>
